import React, { FC } from 'react'
import {
  Icon,
  Button,
  ModalActions,
  ModalContent,
  Header,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { LSPayEcomErrorMessage } from '../helpers/types'

interface ErrorProps {
  lspayError: LSPayEcomErrorMessage
  isRetryable: boolean
  retry?: () => void
  close: () => void
  headingType?: 'heading' | 'sub-heading'
}

const ErrorContent: FC<ErrorProps> = ({
  lspayError,
  retry,
  close,
  isRetryable,
  headingType = 'heading',
}) => {
  const { header, body } = lspayError
  const t = useT()

  return (
    <>
      <ModalContent className="vd-mt0">
        <div className="vd-flex vd-flex--align-center vd-mt8">
          <Header type={headingType} level="2">
            <Icon
              icon="fa-exclamation-triangle"
              className="vd-pr2"
              style={{ color: 'red' }}
            />
            {header}
          </Header>
        </div>
        <div className="vd-mt8">{body}</div>
      </ModalContent>

      <ModalActions>
        {isRetryable ? (
          <>
            <Button variant="supplementary" className="vd-mr2" onClick={close}>
              {t('Choose Another Refund Type', {
                _context: 'Ecom refund error modal button',
              })}
            </Button>
            <Button onClick={retry}>Retry</Button>
          </>
        ) : (
          <Button onClick={close}>
            {t('OK, got it', {
              _context: 'Ecom refund error modal button',
            })}
          </Button>
        )}
      </ModalActions>
    </>
  )
}

export { ErrorContent }
